@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup" (change)="saveForm()">
    <div class="row">
      <div class="col-7">
        <p>In {{ (incomeTaxEntity$ | async)?.year }} betaalde rente over andere jaren</p>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="renteInDitJaarVoorAndereJaren"
                                          id="dubbelePositie"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
    <div class="row">
      <div class="col-7">
        <p>In een ander jaar betaalde rente over {{ (incomeTaxEntity$ | async)?.year }}</p>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="renteInVoorgaandeJarenBetaaldVoorDitJaar"
                                          id="renteInVoorgaandeJarenBetaaldVoorDitJaar"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
    <div class="row">
      <div class="col-7">
        <p>Belast deel van in {{ (incomeTaxEntity$ | async)?.year }} ontvangen uitkering kapitaalverzekering eigen
          woning</p>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="belastDeelKapitaalverzekeringEigenWoningen"
                                          id="belastDeelKapitaalverzekeringEigenWoningen"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
}
